import { EventsService } from './../../common/services/events.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';

import { Event } from './../../common/interfaces/event.interface';
import { SharedProgrammingService } from '../../common/services/shared-programming.service';
import { EVENTS_FILTER } from '../events/eventsUI.service';

@Component({
  selector: 'prg-list-by-room',
  templateUrl: './list-by-room.component.html'
})
export class ListByRoomComponent implements OnInit {
  searchText: Observable<string>;
  deviceEvents: Observable<Event[]>;
  ready: Observable<boolean>;
  expanded: Observable<boolean>;

  @Input() creatorFilter: EVENTS_FILTER;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private store: Store<any>,
    private events: EventsService,
    private shared: SharedProgrammingService
  ) {
    this.deviceEvents = this.events.programmedEvents;
    this.searchText = this.shared.searchText;
    this.ready = this.shared.isReady;
    this.expanded = this.shared.listExpanded;
  }

  ngOnInit() {
    this.shared.clearError();
    this.shared.setGrouping('room');
  }

  private tileClicked(item: any) {
    console.log('tile clicked: ', item);
    if (item) {
      // this.shared.setSelectedEvent(item).then(res => {
      this.router.navigate(['../../device', item.deviceId, 'event', item.eventId, 'edit'], { relativeTo: this.route });
      // });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/list-by-room/list-by-room.component.ts